<template>
  <div>
    <info-row
      :titreSeul="true"
      :intitule="intitule"
      :numero="numero"
    ></info-row>
    <info-row :valeurSeule="true">
      {{ valeur }}
    </info-row>
  </div>
</template>

<script>
import InfoRow from "@/components/InfoFicheDM.vue";
export default {
  components: {
    InfoRow,
  },
  props: {
    intitule: {
      type: String,
      default: "",
    },
    valeur: {
      type: String,
      default: "",
    },
    numero: {
      type: String,
      required: false,
    },
  },
};
</script>

<style></style>
